import React from 'react';
import type { LeadStage } from '@contactrate/shared';

const STAGE_CONFIG: Record<
  LeadStage,
  { label: string; color: string; bg: string; border: string }
> = {
  new: { label: 'New', color: '#64748B', bg: 'rgba(100,116,139,0.1)', border: 'rgba(100,116,139,0.25)' },
  called: { label: 'Called', color: '#2E66E0', bg: 'rgba(46,102,224,0.1)', border: 'rgba(46,102,224,0.25)' },
  contacted: { label: 'Contacted', color: '#0D9488', bg: 'rgba(13,148,136,0.1)', border: 'rgba(13,148,136,0.25)' },
  transfer: { label: 'Live Transfer', color: '#6D4AEA', bg: 'rgba(109,74,234,0.1)', border: 'rgba(109,74,234,0.25)' },
  booked: { label: 'Booked', color: '#D97706', bg: 'rgba(217,119,6,0.1)', border: 'rgba(217,119,6,0.25)' },
  presented: { label: 'Presented', color: '#EA580C', bg: 'rgba(234,88,12,0.1)', border: 'rgba(234,88,12,0.25)' },
  follow_up: { label: 'Follow Up', color: '#DB2777', bg: 'rgba(219,39,119,0.1)', border: 'rgba(219,39,119,0.25)' },
  closed: { label: 'Closed', color: '#159662', bg: 'rgba(21,150,98,0.1)', border: 'rgba(21,150,98,0.25)' },
};

interface StageChipProps {
  stage: LeadStage;
  size?: 'sm' | 'md';
}

export function StageChip({ stage, size = 'md' }: StageChipProps) {
  const cfg = STAGE_CONFIG[stage];
  const px = size === 'sm' ? '6px 8px' : '2px 8px';
  const fs = size === 'sm' ? 10 : 11;

  return (
    <span
      className="stage-chip"
      style={{
        color: cfg.color,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        padding: px,
        fontSize: fs,
      }}
    >
      <span
        className="inline-block w-[5px] h-[5px] rounded-full flex-shrink-0"
        style={{ background: cfg.color }}
      />
      {cfg.label}
    </span>
  );
}

export function stageColor(stage: LeadStage): string {
  return STAGE_CONFIG[stage]?.color ?? '#64748B';
}

export function stageLabel(stage: LeadStage): string {
  return STAGE_CONFIG[stage]?.label ?? stage;
}

export { STAGE_CONFIG };
